// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld-base';
import 'myWorld/uiComponents/dialog';
import './createBookmark';
import './editBookmark';
import './listBookmarks';

myw.BookmarksPlugin = myw.Plugin.extend({
    options: {
        showBookmarkDetail: true
    },

    /**
     * @class Provides bookmark functionality <br/>
     * Adds a button to the toolbar to access a dialog which allows the user to save or manage bookmarks
     * @param  {Application} owner                       The application
     * @param  {object}          options
     * @param  {boolean}         options.showBookmarkDetail  Whether to show the individual bookmark details in the dialog or not
     * @constructs
     * @extends {Plugin}
     */
    initialize(owner, options) {
        myw.Plugin.prototype.initialize.call(this, owner, options);
        this.plugin_name = 'bookmark';
    },

    /**
     * Shows the bookmark window.
     */
    showCreateDialog() {
        if (!this.addDialog) {
            this.addDialog = new myw.CreateBookmarkDialog(this, {
                showBookmarkDetail: this.options.showBookmarkDetail
            });
        }
        this.addDialog.show();
    },

    /**
     * Shows the bookmark window.
     */
    showManageDialog() {
        if (!this.manageDialog) {
            this.manageDialog = new myw.ManageBookmarksDialog({
                owner: this,
                showBookmarkDetail: this.options.showBookmarkDetail
            });
            this.manageDialog.render();
        }
        this.manageDialog.show();
    },

    /**
     * Checks to see if the bookmark name has previously been used
     * @param  {string} name  Name entered for the bookmark
     * @param  {array}  list  List of the user's bookmarks
     * @return {object}       A bookmark with the same name (if any), else returns 'null'
     */
    existsInList(name, list) {
        return _.find(list, bookmark => bookmark.title.toLowerCase() === name.toLowerCase());
    },

    showSaveFailureDialog() {
        this.message(this.msg('update_failed'), 'error');
    },

    message(messageContainer, message, type) {
        new myw.DisplayMessage({ el: messageContainer, type: type, message: message });
    }
});

myw.BookmarksPlugin.prototype.buttons = {
    dialog: myw.PluginButton.extend({
        id: 'a-bookmarks', //for automated tests
        titleMsg: 'toolbar_msg',
        imgSrc: 'images/toolbar/bookmark.svg',
        action() {
            this.app.recordFunctionalityAccess('core.toolbar.bookmark');
            this.owner.showCreateDialog();
        }
    })
};

export default myw.BookmarksPlugin;
